import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import CommonWombatCredits from '../../CommonWombatCredits';
import SvgSmallWombatLogo from '../../SmallWombatLogo';
import useWindowWidth from '../../../hooks/useWindowWidth';


const StyledFooter = styled.footer`
  background-color: ${({ theme }) => theme.colors.dark};
  display: flex;
  justify-content: center;
  align-items: center;  
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    justify-content: center;
  }
`;

const StyledCredits = styled.div`
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    margin-right: 230px ;
  }
`;

const Text = styled.span`  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    font-size: ${({ theme }) => theme.fontSize.small};
  }
`;

const FooterSection = () => {
  const theme = useContext(ThemeContext);
  const width = useWindowWidth();

  if (typeof window === 'undefined') {
    return <></>;
  }

  return (
    <StyledFooter>
      <Content>
        { typeof document !== 'undefined' && (
          <StyledCredits>
            {width > theme.screenSizeWidthWithoutPx.medium ? (
              <CommonWombatCredits
                primaryColor={theme.colors.white}
                secondaryColor={theme.colors.dark}
                primaryColorOnHover={theme.colors.orange}
              />
            ) : (
              <SvgSmallWombatLogo
                primaryColor={theme.colors.white}
                primaryColorOnHover={theme.colors.orange}
              />
            )}
          </StyledCredits>
        )}
        <Text>
          Copyright © MIŁOSZ KAFFKA 2021
        </Text>
      </Content>
    </StyledFooter>
  );
};

export default FooterSection;
